import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { SharedHeadTitleTag } from '../../shared/SharedHead/SharedHeadTitleTag.tsx';
import { SharedHeadMetaTags } from '../../shared/SharedHead/SharedHeadMetaTags.tsx';
import { SharedHeadLinkTags } from '../../shared/SharedHead/SharedHeadLinkTags.tsx';
import { SharedHeadScriptTags } from '../../shared/SharedHead/SharedHeadScriptTags.tsx';
import { filterFalsy } from 'dibs-ts-utils/exports/filterFalsy.ts';

import { type SbSharedHead_itemSearch$key } from './__generated__/SbSharedHead_itemSearch.graphql.ts';

const itemSearchFragment = graphql`
    fragment SbSharedHead_itemSearch on ItemSearchQueryConnection {
        meta {
            ...SharedHeadTitleTag_metadata
            ...SharedHeadMetaTags_metadata
            ...SharedHeadLinkTags_metadata
            ...SharedHeadScriptTags_metadata
        }
        edges {
            node {
                item {
                    ...SharedHeadMetaTags_items
                }
            }
        }
    }
`;

type Props = {
    itemSearch: SbSharedHead_itemSearch$key;
    imageFallback?: string | null;
};

export const SbSharedHead: FC<Props> = ({ itemSearch: itemSearchRef, imageFallback }) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const { meta: metadata, edges } = itemSearch;
    const items = edges?.map(edge => edge?.node?.item).filter(filterFalsy) || [];

    return (
        <>
            <SharedHeadTitleTag metadata={metadata} />
            <SharedHeadMetaTags metadata={metadata} items={items} imageFallback={imageFallback} />
            <SharedHeadLinkTags metadata={metadata} />
            <SharedHeadScriptTags metadata={metadata} />
        </>
    );
};
